import {useEffect, useMemo, useRef} from 'react';
import {getCDP} from '.';
import {cdpStrategy} from '../logCenter';
import {useUserData} from '@app/hooks/controllers/useUserData';
import {useUserConsent} from '@tempo/cookie';
import type {TraitEvent} from '@deezer/logcenter/build/types/Sender/CDPSender/types';
import {getUniqId} from '../utils';
import {useAutolog} from '@app/hooks/auth/useAutolog';
import {AuthStatus} from '@app/hooks/auth/useAutolog/utils';
import {prepareSegment} from './privacy';

export function useUserIdentifyProfile(): TraitEvent | null {
	const {user} = useUserData();
	const {data} = useAutolog();
	const {consentSettings} = useUserConsent();

	return useMemo(() => {
		if (!consentSettings) return null;

		const profile: TraitEvent = {
			statistics: !!consentSettings.statistics,
			targetedAds: !!consentSettings.targetedAdvertising,
			deezer_unique_id: getUniqId(),
			userId: (data as any)?.user_id?.toString(),
		};
		if (user?.email) {
			profile.email = user?.email;
		}
		return profile;
	}, [consentSettings, data, user?.email]);
}

/**
 * @deprecated - For init use only, prefer using the one from @app/modules/tracking instead
 */
export const useInitCDP = () => {
	const profile = useUserIdentifyProfile();
	const {status} = useAutolog();
	const initialized = useRef(false);

	useEffect(() => {
		if (!profile || status === AuthStatus.loading || initialized.current)
			return;
		initialized.current = true;
		const cdp = getCDP();
		prepareSegment(status === AuthStatus.unlogged);
		cdp.init();
		cdp.identify(profile);
		cdpStrategy.openGate();
	}, [profile, status]);
	return Boolean(profile);
};
